import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import useSelector from 'hooks/useSelector';
import { UserProfile } from 'shared/models/site/user-profile';
import { ExpandMore } from '@mui/icons-material';
import './UserApprovals.css';

import {
    userApprovalsPendingPathRoute
} from "components/portal/userApprovals/UserApprovalsRoutes";

import {
    Label,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu
} from 'reactstrap';
import { ISelectOption } from '../forms/util';

const getUserApprovalsPendingPathRoute = () => { return userApprovalsPendingPathRoute; };

export const pending = {
    label: "Pending",
    value: "pending",
    getRoute: getUserApprovalsPendingPathRoute
} as ISelectOption;

interface UserApprovalsPageSelectorProps {
    selectedPage: ISelectOption
}

export const UserApprovalsPageSelector = (props: UserApprovalsPageSelectorProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const [selectOptions, setSelectOptions] = useState([props.selectedPage] as ISelectOption[]);
    const profile = useSelector(state => state.profile);
    const navigate = useNavigate();

    const getSelectOptions = (user: UserProfile) => {
        var options: ISelectOption[] = [];
        options.push(pending);
        return options;
    };

    const selectOnChange = (selectOption: ISelectOption) => {
        var path = selectOption.getRoute().path;
        if (selectOption !== currentSelection && typeof (path) === 'string') {
            navigate(path);
        }
    };

    useEffect(() => {
        if (currentSelection === undefined) {
            setCurrentSelection(pending);
        }

        if (profile && selectOptions.length <= 1) {
            setSelectOptions(getSelectOptions(profile));
        }
    }, [profile, selectOptions]);

    return (
        <div className="user-approvals-selector ua-narrow">
            <UncontrolledDropdown>
                <DropdownToggle tag="div" className="rbt-input-main form-control rbt-input">
                    <div className="ua-select-options">{currentSelection.label}</div>
                </DropdownToggle>
                <ExpandMore />
                <DropdownMenu className="ua-page-selector">
                    {selectOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`form-check-inline dropdown-item ${ option.value }${ option.subitem ? ' sub-item' : '' }`}
                            onClick={() => selectOnChange(option)}>
                            <Label className={`form-check-label`}>{option.label}</Label>
                        </div>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
};
